import { groupBy, mapValues } from "lodash";

import { IEntityFetchCollectionSuccess, RequestAction } from "../actions";
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { IEntityCollectionState } from "../reducer";

import { SpamAction, SpamActionNames } from "./actions";
import { ISpamEntry } from "./interfaces";

export interface ISpamStoreState {
  blocked?: null | IEntityCollectionState<ISpamEntry>;
  trusted?: null | IEntityCollectionState<ISpamEntry>;
}

const initialState: ISpamStoreState = {
  blocked: undefined,
  trusted: undefined,
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const spamReducer = (state: ISpamStoreState = initialState, action: SpamAction) => {
  switch (action.type) {
    case SpamActionNames.FETCH_BLOCKED_LIST[RequestAction.SUCCESS]: {
      return {
        ...state,
        blocked: mapValues(
          groupBy((action.payload as IEntityFetchCollectionSuccess<ISpamEntry>).values, e => e.id),
          x => x[0]
        ),
      };
    }
    case SpamActionNames.FETCH_TRUSTED_LIST[RequestAction.SUCCESS]: {
      return {
        ...state,
        trusted: mapValues(
          groupBy((action.payload as IEntityFetchCollectionSuccess<ISpamEntry>).values, e => e.id),
          x => x[0]
        ),
      };
    }
    case SpamActionNames.FETCH_BLOCKED_LIST[RequestAction.FAILURE]: {
      return { ...state, blocked: null };
    }
    case SpamActionNames.FETCH_TRUSTED_LIST[RequestAction.FAILURE]: {
      return { ...state, trusted: null };
    }
    case SpamActionNames.SYNC_BLOCKED_DELETE: {
      const { id } = action.payload as { id: string };

      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { [id]: _unused, ...rest } = state.blocked || {};
      return { ...state, blocked: rest };
    }
    case SpamActionNames.SYNC_TRUSTED_DELETE: {
      const { id } = action.payload as { id: string };

      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { [id]: _unused, ...rest } = state.trusted || {};
      return { ...state, trusted: rest };
    }
    case SpamActionNames.ADD_BLOCKED_ENTRY[RequestAction.SUCCESS]: {
      const entry = action.payload as ISpamEntry | null;

      if (entry !== null) {
        return { ...state, blocked: { ...state.blocked, [entry.id]: entry } };
      }

      return state;
    }
    case SpamActionNames.ADD_TRUSTED_ENTRY[RequestAction.SUCCESS]: {
      const entry = action.payload as ISpamEntry | null;

      if (entry !== null) {
        return { ...state, trusted: { ...state.trusted, [entry.id]: entry } };
      }

      return state;
    }
    default:
      return state;
  }
};
